import { UIKitTheme } from 'ui/themes/getUIKitTheme'

export const getHoverTextColor = (theme: UIKitTheme, overColoredPad = false) => {
  if (overColoredPad) {
    return theme.uiKit.colors.theme.brand.primary
  }
  return theme.uiKit.colors.global.general.main
}
